<template>
  <div class="auto-mobile" v-loading="loading">
    <div v-show="showPrincipal">
      <div class="row row-custom auto-header">
        <div class="col-14 titolo no-padding">
          <span>{{ $t('auto.label.title') }}</span>
        </div>
        <div class="col-10 action no-padding">
          <div class="add" v-if="!formDisabled" @click="add">
            <icon name="riv-add_2" scale="2" class="pointer"></icon>
          </div>
        </div>
      </div>

      <el-table :data="auto" @row-click="open" :empty-text="$t('auto.msg.noData')" class="el-table_mobile"
        :row-class-name="tableRowClassName">

        <el-table-column header-align="center" align="center" width="30">

          <template slot-scope="scope" slot="header">
            <div class="icon-title" :key="scope.length">
              <el-popover placement="top" v-model="visibleInfo">
                <div>
                  <div>
                    <icon name="riv-circle" class="status-saved" scale="0.8"></icon>
                    <span>{{ $t('statusDett.0') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-send" scale="0.8"></icon>
                    <span>{{ $t('statusDett.1') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-rejected" scale="0.8"></icon>
                    <span>{{ $t('statusDett.2') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-approved" scale="0.8"></icon>
                    <span>{{ $t('statusDett.3') }}</span>
                  </div>
                </div>

                <span slot="reference">
                  <icon class="pointer" name="riv-help" scale="1"></icon>
                </span>
              </el-popover>

            </div>
          </template>


          <template slot-scope="scope">
            <div class="data-wrapper">
              <el-tooltip class="item" effect="dark" :content="$t('statusDett.' + scope.row.statoAvanz)"
                placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoAvanz)" :class="getStatoClass_dett(scope.row.statoAvanz)"
                  scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('auto.label.giorno')" width="100"
          class-name="sfondino">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <span class="block">{{ scope.row.giorno | formattaData }}</span>
              <span class="block" v-if="scope.row.id === ''"></span>
              <span class="block" v-else>{{ scope.row.oraDal | formattaHours }} / {{ scope.row.oraAl | formattaHours
                }}</span>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" :label="$t('auto.label.ritiro')" class-name="">

          <template slot-scope="scope">
            <div class="name-wrapper truncate-overflow">
              {{ scope.row.desLuogoRitiro }}
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" width="30">

          <template slot-scope="scope" slot="header">
            <div class="icon-title" :key="scope.length">
              <el-tooltip class="item" effect="dark" :content="$t('auto.label.telepass')" placement="top-start">
                <icon name="riv-telepass" scale="1.2"></icon>
              </el-tooltip>
            </div>
          </template>

          <template slot-scope="scope">
            <div class="data-wrapper">
              <icon v-if="scope.row.telepass === '1'" name="riv-tick" scale="1.2"></icon>
            </div>
          </template>
        </el-table-column>

        <el-table-column header-align="center" align="center" width="30">

          <template slot-scope="scope" slot="header">
            <div class="icon-title" :key="scope.length">
              <el-tooltip class="item" effect="dark" :content="$t('auto.label.navigator')" placement="top-start">
                <icon name="riv-navigatore" scale="1.2"></icon>
              </el-tooltip>
            </div>
          </template>

          <template slot-scope="scope">
            <div class="data-wrapper">
              <icon v-if="scope.row.navigatore === '1'" name="riv-tick" scale="1.2"></icon>
            </div>
          </template>
        </el-table-column>

        <el-table-column header-align="center" align="center" width="30">

          <template slot-scope="scope">
            <div class="name-wrapper" :key="scope.length" @click.stop.prevent v-if="enableAction('del')">
              <el-tooltip placement="left" popper-class="popover-mobile" effect="light">
                <template slot="content">
                  <div @click="del(scope.row)" v-if="enableAction('del')">
                    <span>{{ $t('auto.label.delete') }}</span>
                  </div>
                </template>
                <icon class="pointer action" name="riv-more" scale="1.5"></icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" background layout="prev, pager, next"
        :total="nrItems" :page-size="pag_for" @current-change="changePage">
      </el-pagination>
    </div>
    <!-- Dialog di creazione di una nuova richiesta di ferie -->
    <div v-show="showModal" class="el-form_mobile">
      <div class="el-form-header row row-custom">
        <div class="el-form-action col-2 no-padding">
          <icon name="riv-arrow2" scale="1.2" flip="horizontal" @click.native="closeModal('showModal')"></icon>
        </div>
        <div class="el-form-title col-20 no-padding">
          {{ $t('auto.label.title').toUpperCase() }}
        </div>
      </div>

      <el-form class="el-form-body" :disabled="formDisabled">
        <div class="elemento row row-custom" v-if="form.id !== ''">
          <div class="el-form-label col-24 no-padding">{{ $t('auto.label.giorno') }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="form.giorno" :disabled="formDisabled" :class="formDisabled ? 'field-disabled' : ''">
                <option v-for="(item) in picker_days" :value="item.value" :key="item.value">{{ item.label }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom" v-if="form.id === ''">
          <div class="el-form-label col-24 no-padding">{{ $t('auto.label.dataDal') }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="form.dataDal" :disabled="formDisabled" :class="formDisabled ? 'field-disabled' : ''">
                <option v-for="(item) in picker_days" :value="item.value" :key="item.value">{{ item.label }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom" v-if="form.id === ''">
          <div class="el-form-label col-24 no-padding">{{ $t('auto.label.dataAl') }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="form.dataAl" :disabled="formDisabled" :class="formDisabled ? 'field-disabled' : ''">
                <option v-for="(item) in picker_days" :value="item.value" :key="item.value">{{ item.label }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaAuto && (this.form.oraDal === undefined || this.form.oraDal === null || this.form.oraAl === undefined || this.form.oraAl === null) ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('auto.label.orario') + ' (*)' }}</div>
          <div class="el-form-input col-12 padding-right">
            <div class="input-wrapper">
              <input type="time" v-model="form.oraDal" class="first" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
          <div class="el-form-input col-12 padding-left">
            <div class="input-wrapper">
              <input type="time" v-model="form.oraAl" class="first" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>
        <div class="elemento row row-custom"
          :class="[!this.validaAuto && (this.form.luogoRitiro === undefined || this.form.luogoRitiro === '') ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('auto.label.ritiro') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="form.luogoRitiro" :disabled="formDisabled" :class="formDisabled ? 'field-disabled' : ''">
                <option v-for="(item) in tbl_genSta" :value="item.id" :key="item.id">{{ item.desc }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('auto.label.utilizzo') }}</div>
          <div class="el-form-input col-24 no-padding" style="height: 100%;">
            <div class="input-wrapper">
              <textarea v-model="form.utilizzo" class="first" rows="5" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="el-form-label col-22 no-padding">
            {{ $t('auto.label.telepass') }}
          </div>
          <div class="el-form-label col-2 no-padding">
            <el-checkbox v-model="form.checkedTelepass" :indeterminate="false"></el-checkbox>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="el-form-label col-22 no-padding">
            {{ $t('auto.label.navigator') }}
          </div>
          <div class="el-form-label col-2 no-padding">
            <el-checkbox v-model="form.checkedNavigator" :indeterminate="false"></el-checkbox>
          </div>
        </div>

        <div v-if="form.statoAvanz !== '0'">
          <div class="elemento row row-custom">
            <div class="my-area col-24 no-padding">
              {{ $t('auto.label.segreteria') }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.modello !== '' && form.targa !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('auto.label.modelloAuto') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.modello }} - {{ form.targa }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.nrTelepass !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('auto.label.telepassNr') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.nrTelepass }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.notaSeg !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('auto.label.noteSegreteria') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.notaSeg }}
            </div>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="">
        <el-button class="mobile-el-button primary" v-if="trasferta.terminata !== 'T'" @click="checkSave()">{{
          $t('btn.salva')}}</el-button>
        <el-button class="mobile-el-button secondary" v-if="trasferta.terminata === 'T'"
          @click="closeModal('showModal')">{{
            $t('btn.close')
          }}</el-button>
        <el-button class="mobile-el-button secondary" v-if="trasferta.terminata !== 'T'"
          @click="closeModal('showModal')">{{
            $t('btn.annulla')
          }}</el-button>
      </span>

    </div>
    <!--</el-dialog>-->
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'autoMobile',
  props: ['trasferta', 'tbl_genSta'],
  i18n: {
    messages: {
      it_IT: {
        auto: {
          label: {
            title: 'Auto Aziendale',
            giorno: 'Giorno',
            giorniPre: 'Giorni Prenotati',
            orario: 'Orario',
            note: 'Nota',
            telepass: 'Telepass',
            telepassNr: 'Numero Telepass',
            navigator: 'Navigatore GPS',
            modelloAuto: 'Modello Auto',
            ritiro: 'Luogo di Ritiro',
            utilizzo: 'Utilizzo',
            segreteria: 'Segreteria',
            noteSegreteria: 'Note Segreteria',
            allegati: 'Allegati',
            inizio: 'Inizio',
            fine: 'Fine',
            delete: 'Elimina',
            incolla: 'Incolla',
            dataDal: 'Giorno Ritiro',
            dataAl: 'Giorno Riconsegna'
          },
          msg: {
            noData: 'Nessun Documento trovato',
            infoSel: 'Per aprire una singola prenotazione è necessario rimuove i flag di selezione multipla',
            noDocsSel: 'Nessun documento selezionato',
            datiObbligatoriMancanti: 'Dati obbligatori mancanti'
          }
        }
      },
      fr_FR: {
        auto: {
          label: {
            title: 'Réserver Voiture de société',
            giorno: 'Jour',
            giorniPre: 'Jours réservés',
            orario: 'Horaire',
            note: 'Notes',
            telepass: 'Boitier de péage',
            telepassNr: 'Numéro boit. de péage',
            navigator: 'Navigateur',
            modelloAuto: 'Modèle de voiture',
            ritiro: 'Départ',
            utilizzo: 'Utilisation',
            segreteria: 'Secrétaire',
            noteSegreteria: 'Annotations de la Secrétaire',
            allegati: 'Annexes',
            inizio: 'de',
            fine: 'à',
            delete: 'Supprimer',
            incolla: 'Coller',
            dataDal: 'Jour de retrait',
            dataAl: 'Jour de retour'
          },
          msg: {
            noData: 'Aucun Réserver Voiture de société trouvé',
            infoSel: 'Pour ouvrir une seule reservation est nécessaire enlever l\'indicateur de sélection multiple',
            noDocsSel: 'Aucun document sélectionné',
            datiObbligatoriMancanti: 'Données obligatoires manquantes'
          }
        }
      },
      es_ES: {
        auto: {
          label: {
            title: 'Coche De La Sociedad',
            giorno: 'Día',
            giorniPre: 'Día de reserva',
            orario: 'Horas',
            note: 'Notes',
            telepass: 'Telepass',
            telepassNr: 'Número Telepass',
            navigator: 'Navegador GPS',
            modelloAuto: 'Modelo de coche',
            ritiro: 'Lugar de recogida',
            utilizzo: 'Uso',
            segreteria: 'Secretaria',
            noteSegreteria: 'Nota de la Secretaria',
            allegati: 'Adjuntos',
            inizio: 'de',
            fine: 'a',
            delete: 'Borrar',
            incolla: 'Pegar',
            dataDal: 'Día de recogida',
            dataAl: 'Día de entrega'
          },
          msg: {
            noData: 'Sin informacion',
            infoSel: 'Para abrir una sola reserva es necesario eliminar los indicadores de selección múltiple.',
            noDocsSel: 'Ningún documento seleccionado',
            datiObbligatoriMancanti: 'Faltan datos obligatorios'
          }
        }
      },
      de_DE: {
        auto: {
          label: {
            title: 'Firmenfahrzeug',
            giorno: 'Tag',
            giorniPre: 'Tag der Reservierung',
            orario: 'Zeitraum',
            note: 'Notiz',
            telepass: 'Telepass',
            telepassNr: 'Telepassnummer',
            navigator: 'GPS-Navigator',
            modelloAuto: 'Auto',
            ritiro: 'Abholungsort',
            utilizzo: 'Benutzung',
            segreteria: 'Sekretariat',
            noteSegreteria: 'Notiz Sekretariat',
            allegati: 'Anlage',
            inizio: 'von',
            fine: 'bis',
            delete: 'löschen',
            incolla: 'Einfügen',
            dataDal: 'Abholtag',
            dataAl: 'Rückgabetag'
          },
          msg: {
            noData: 'Kein Dokument gefunden',
            infoSel: 'Um eine einzelne Reservierung zu öffnen, müssen die Mehrfachauswahlflags entfernt werden',
            noDocsSel: 'Keine Dokumente ausgewählt',
            datiObbligatoriMancanti: 'Fehlende Pflichtangaben'
          }
        }
      },
      en_GB: {
        auto: {
          label: {
            title: 'Company Car',
            giorno: 'Day',
            giorniPre: 'Booked Days',
            orario: 'Time',
            note: 'Note',
            telepass: 'Telepass',
            telepassNr: 'Telepass Number',
            navigator: 'GPS Navigator',
            modelloAuto: 'Car Model',
            ritiro: 'Pick-up Location',
            utilizzo: 'Usage',
            segreteria: 'Secretariat',
            noteSegreteria: 'Secretariat Notes',
            allegati: 'Attachments',
            inizio: 'Start',
            fine: 'End',
            delete: 'Delete',
            incolla: 'Paste',
            dataDal: 'Pick-up Day',
            dataAl: 'Return Day'
          },
          msg: {
            noData: 'No Document Found',
            infoSel: 'To open a single booking, please remove the multi-selection flags',
            noDocsSel: 'No document selected',
            datiObbligatoriMancanti: 'Required data missing'
          }
        }
      }
    }
  },
  data() {
    return {
      showPrincipal: true,
      visibleInfo: false,
      loading: false,
      auto: [],
      autoSel: [],
      indexCopy: '',
      currentPage: 1,
      pag_for: 14,
      pag_order: 'DD',
      nrPages: 0,
      nrItems: 0,
      showModal: false,
      form: {},
      tbl_mezzi: [],
      formDisabled: false,
      validaAuto: true,
      picker_days: [],
      conformita: 'N'
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    },
    formattaHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    }
  },
  beforeMount: function () {
    this.formDisabled = this.trasferta.terminata === 'T' ? true : false
    this.loading = true
    this.loadAutoAzi()

    moment.locale(this.$i18n.locale)

    const dataDal = moment(this.trasferta.dataDal, 'YYYYMMDD')
    const dataAl = moment(this.trasferta.dataAl, 'YYYYMMDD')
    const numDays = dataAl.diff(dataDal, 'days') + 1

    this.picker_days = Array.from({ length: numDays }, (_, i) => {
      const giorno = dataDal.clone().add(i, 'days')
      return {
        value: giorno.format('YYYYMMDD'),
        label: giorno.format('dddd Do MMM YYYY')
      }
    })
  },
  mounted: function () {
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.copia) {
        return 'row-copy'
      } else if (row.sel) {
        return 'row-sel'
      }
      return ''
    },
    loadAutoAzi: function () {
      this.loading = true
      this.$set(this, 'auto', [])
      console.log(this.trasferta)

      this.$http.get('trasferte/' + this.$store.state.country + '/autoAzi', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.pag_order,
          dataDal: this.trasferta.dataDal,
          dataAl: this.trasferta.dataAl,
          vista: this.actionBar ? '' : 'R'
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.auto = response.body.data
            if (this.currentPage === 1) {
              const pages = response.body.attrib && response.body.attrib.pages
              const size =  response.body.attrib && response.body.attrib.size
              const conformita =  response.body.attrib && response.body.attrib.conformita
              this.$set(this, 'nrPages', pages ? parseInt(pages) : 1)
              this.$set(this, 'nrItems', size ? parseInt(size) : 0)
              this.$set(this, 'conformita', conformita ? conformita : 'N')
            }
          } else {
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.loading = false
        })
    },
    /*loadAutoAzi: function () {
      this.loading = true
      this.$set(this, 'auto', [])

      let dataDal = moment(this.trasferta.dataDal, 'YYYYMMDD').add(((this.currentPage - 1) * this.pag_for), 'd')
      let dataAl = moment(dataDal.format('YYYYMMDD'), 'YYYYMMDD').add(this.pag_for - 1, 'd')
      //let dataServizioStr = dataDal.format('YYYYMMDD')
      let numDay = dataAl.diff(dataDal, 'days')
      let exDay = dataAl.diff(this.trasferta.dataAl, 'days')

      numDay = (exDay > 0 && (exDay <= numDay) ? (numDay - exDay) : numDay)
      var idTrasferta = this.trasferta.idTrasferta

      for (let i = 0; i <= numDay; i++) {
        let auto = {
          idTrasferta: idTrasferta,
          id: '',
          statoAvanz: '',
          giorno: moment(dataDal.format('YYYYMMDD'), 'YYYYMMDD').add(i, 'd').format('YYYYMMDD'),
          oraDal: '',
          oraAl: '',
          navigatore: '0',
          telepass: '0',
          nrTelepass: '',
          targa: '',
          modello: '',
          luogoRitiro: '',
          desLuogoRitiro: '',
          notaSeg: '',
          utilizzo: '',
          sel: false,
          copia: false
        }
        this.auto.push(auto)
      }

      // Gestisco il paginator
      this.nrItems = moment(this.trasferta.dataAl, 'YYYYMMDD').diff(moment(this.trasferta.dataDal, 'YYYYMMDD'), 'days') + 1
      let numPagesResto = (this.nrItems % this.pag_for > 0 ? 1 : 0)
      let numPages = Math.floor(this.nrItems / this.pag_for) + numPagesResto
      this.nrPages = numPages

      this.$http.get('trasferte/' + this.$store.state.country + '/autoAzi', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          pag_action: 'BEGIN', // (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: '1', // this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.pag_order,
          dataDal: dataDal.format('YYYYMMDD'),
          dataAl: dataAl.format('YYYYMMDD')
        }
      })
        .then(response => {
          if (response.body.rc === 0) {

            this.auto = this.auto.map(function (obj) {
              for (let i = 0; i < response.body.data.length; i++) {
                if (obj.giorno == response.body.data[i].giorno) {
                  response.body.data[i].sel = false
                  response.body.data[i].copia = false
                  return response.body.data[i]
                }
              }
              return obj
            })
            //this.auto = response.body.data
          } else {
            //this.$set(this, 'nrPages', 0)
            //this.$set(this, 'nrItems', 0)
          }
          this.loading = false
        })
    },*/
    setConformita: function () {
      let data = {
        idTrasferta: this.trasferta.idTrasferta,
        operazione: "Y"
      }
      this.$http.post('trasferte/' + this.country + '/conformitaauto', data, {
        params: {
          codLang: sessionStorage.getItem('codLang')
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.conformita = 'Y'
            this.validaAuto = true
            this.$set(this, 'form', {})
            //this.$set(this.form, 'giorno', this.trasferta.dataDal)
            this.$set(this.form, 'dataDal', this.trasferta.dataDal)
            this.$set(this.form, 'dataAl', this.trasferta.dataAl)
            this.$set(this.form, 'checkedTelepass', false)
            this.$set(this.form, 'checkedNavigator', false)
            this.form.id = ''
            this.form.idTrasferta = this.trasferta.idTrasferta
            this.form.statoAvanz = '0'
            this.openModal("showModal")
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    add: function () {
      if (this.conformita !== 'Y') {
        let _this = this
        this.$confirm(
          this.$i18n.t('trasferte.conformita.testo'),
          this.$i18n.t('trasferte.conformita.titolo'),
          {
            confirmButtonText: this.$i18n.t('btn.conferma'),
            cancelButtonText: this.$i18n.t('btn.annulla'),
            dangerouslyUseHTMLString: true,
            customClass: 'my-custom-confirm',
            callback: function (action) {
              if (action === 'confirm') {
                _this.setConformita()
              } else {
                _this.$message({
                  showClose: true,
                  message: _this.$i18n.t('trasferte.conformita.abort'),
                  type: 'info',
                  duration: process.env.duration
                })
              }
            }
          }
        )
      } else {
        this.validaAuto = true
        this.$set(this, 'form', {})
        this.$set(this.form, 'dataDal', this.trasferta.dataDal)
        this.$set(this.form, 'dataAl', this.trasferta.dataAl)
        this.$set(this.form, 'checkedTelepass', false)
        this.$set(this.form, 'checkedNavigator', false)
        this.form.id = ''
        this.form.idTrasferta = this.trasferta.idTrasferta
        this.form.statoAvanz = '0'
        this.openModal("showModal")
      }
    },
    open: function (row, event, column) {
      this.validaAuto = true

      this.$set(this, 'form', {})
      this.form.id = row.id
      this.form.statoAvanz = row.statoAvanz
      this.$set(this.form, 'giorno', row.giorno, "YYYYMMDD")
      this.$set(this.form, 'oraDal', moment(row.oraDal, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'oraAl', moment(row.oraAl, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'luogoRitiro', row.luogoRitiro)
      this.$set(this.form, 'utilizzo', row.utilizzo.split("\\n").join("\n"))
      this.$set(this.form, 'checkedTelepass', row.telepass === '1' ? true : false)
      this.$set(this.form, 'checkedNavigator', row.navigatore === '1' ? true : false)

      //Segreteria
      this.form.modello = row.modello
      this.form.targa = row.targa
      this.form.nrTelepass = row.nrTelepass
      this.form.notaSeg = row.notaSeg
      this.openModal("showModal")
    },
    checkSave: function () {
      this.validaAuto = true
      if (this.form.id === '' && (this.form.dataDal === '' || this.form.dataAl === '')) {
        this.validaAuto = false
      }
      if (this.form.id !== '' && (this.form.giorno === '')) {
        this.validaAuto = false
      }
      if (this.form.oraDal === null || this.form.oraDal === undefined) {
        this.validaAuto = false
      }
      if (this.form.oraAl === null || this.form.oraAl === undefined) {
        this.validaAuto = false
      }
      if (this.form.luogoRitiro === '' || this.form.luogoRitiro === undefined) {
        this.validaAuto = false
      }

      if (this.validaAuto) {
        this.save()
      } else {
        this.$message.error(this.$i18n.t('auto.msg.datiObbligatoriMancanti'))
      }
    },
    save: function () {
      this.loading = true;

      let idPrenotazioni = [];

      if (this.form.id !== '') {
        idPrenotazioni.push({
          giorno: this.form.giorno,
          id: this.form.id
        });
      } else {
        const dataDal = moment(this.form.dataDal, 'YYYYMMDD');
        const dataAl = moment(this.form.dataAl, 'YYYYMMDD');
        const numDays = dataAl.diff(dataDal, 'days') + 1;

        for (let i = 0; i < numDays; i++) {
          idPrenotazioni.push({
            giorno: moment(dataDal).add(i, 'days').format('YYYYMMDD'),
            id: ''
          });
        }
      }

      const obj = {
        idTrasferta: this.trasferta.idTrasferta,
        oraDal: moment(this.form.oraDal, 'HH:mm').format('HH.mm.ss'),
        oraAl: moment(this.form.oraAl, 'HH:mm').format('HH.mm.ss'),
        luogoRitiro: this.form.luogoRitiro,
        utilizzo: this.form.utilizzo,
        navigatore: this.form.checkedNavigator ? '1' : '0',
        telepass: this.form.checkedTelepass ? '1' : '0',
        idPrenotazioni: JSON.stringify(idPrenotazioni),
        statoAvanz: this.form.statoAvanz
      };

      this.$http.post('trasferte/' + this.$store.state.country + '/autoAzi', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadAutoAzi()
            this.closeModal("showModal")
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    del: function (row) {
      this.loading = true
      this.$http.delete('trasferte/' + this.$store.state.country + '/autoAzi/' + row.idTrasferta + '/' + row.id)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadAutoAzi()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.loadAutoAzi()
    },
    isDisabled: function () {
      if (this.trasferta.terminata === 'T' || this.form.id != '') {
        return true
      } else {
        return false
      }
    },
    enableAction: function (action, row) {
      let statoTrasferta = this.trasferta.statoAvanz
      if (this.trasferta.terminata === 'T') {
        return false
      }
      switch (action) {
        case 'del':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '5') {
            return true
          } else {
            return false
          }
        case 'add':
        case 'copy':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') {
            return true
          } else {
            return false
          }
      }
      return false
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
          return 'riv-circle'
        default:
          return ''
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    },
    openModal: function (field) {
      this.$set(this, field, true)
      this.$set(this, 'showPrincipal', false)
      this.$emit('showModalComponent', false)
    },
    closeModal: function (field) {
      this.$set(this, field, false)
      this.$set(this, 'showPrincipal', true)
      this.$emit('showModalComponent', true)
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-table_mobile.less";
@import "../../assets/less/el-form_mobile.less";

.auto-mobile {
  // height: 100%;
  //min-width: 1250px;
  margin-bottom: 70px;
  max-width: 100%;

  .auto-header {
    height: 40px;
    margin-top: 10px;
    margin-bottom: 10px;

    .titolo {
      .set-font(@size: 16px, @color: @greenRiva, @family: "os-bold");
      text-align: left;
      line-height: 40px;
    }

    .action {
      text-align: right;
      line-height: 40px;

      .add {
        // position: fixed;
        // right: 20px;
        // bottom: 20px;
        float: right;
        color: #FF791A;
        margin-right: 10px;
        margin-left: 10px;
      }

      .send {
        // position: fixed;
        // right: 20px;
        // bottom: 20px;
        float: right;
        color: #FF791A;
        margin-right: 10px;
        margin-left: 10px;
      }
    }
  }

  .el-checkbox {
    margin-bottom: 0px;
    margin-top: 10px;

    .el-checkbox__inner {
      border-radius: 0px;
    }

    &.is-checked {
      .el-checkbox__inner {
        background-color: @greenRiva;
        border-color: @greenRiva;
      }
    }
  }

  .popover-mobile {
    line-height: 50px;
    .set-font(@size: 18px, @color: @grayTesto, @family: "os-semibold")
  }

  .el-table {

    .el-table__body {
      tbody {
        tr {
          &.expanded {
            background-color: #e7e7e7;

            td {
              background-color: #e7e7e7 !important;
            }
          }

          &.row-copy {
            background-color: #b5d2d0;

            .truncate-overflow::after {
              background: #b5d2d0 !important;
            }
          }

          &.row-copy:hover>td {
            background-color: #b5d2d0 !important;
          }

          &.row-sel {
            background-color: #eaeaea;

            .truncate-overflow::after {
              background: #eaeaea !important;
            }
          }

          &.row-sel:hover>td {
            background-color: #eaeaea !important;
          }

          &.hover-row {
            td {
              background-color: @white;
            }
          }

          &.single {
            .el-table__expand-icon {
              display: none;
            }
          }
        }
      }
    }
  }

  .row {
    &.row-error {
      .el-form-label {
        color: red !important;
      }
    }
  }
}

.my-custom-confirm {
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/TrasferteMobile/AutoAziendaliMobile.vue